import { render, staticRenderFns } from "./EventMyPlace.vue?vue&type=template&id=5da06dc7&"
import script from "./EventMyPlace.vue?vue&type=script&lang=js&"
export * from "./EventMyPlace.vue?vue&type=script&lang=js&"
import style0 from "./EventMyPlace.vue?vue&type=style&index=0&id=5da06dc7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports